import type { Dimension } from '../types';
import './DimensionTabs.css';

interface DimensionTabsProps {
  active: Dimension;
  onChange: (dimension: Dimension) => void;
}

const dimensions: { id: Dimension; label: string; number: number }[] = [
  { id: 'generate', label: 'GENERATE', number: 1 },
  { id: 'retake', label: 'RETAKE', number: 2 },
  { id: 'repaint', label: 'REPAINT', number: 3 },
  { id: 'edit', label: 'EDIT', number: 4 },
  // { id: 'extend', label: 'EXTEND', number: 5 }, // Disabled - ACE-Step extend not working reliably
];

export function DimensionTabs({ active, onChange }: DimensionTabsProps) {
  return (
    <div className="dimension-tabs">
      {dimensions.map((dim) => (
        <button
          key={dim.id}
          className={`dimension-tab ${active === dim.id ? 'active' : ''}`}
          onClick={() => onChange(dim.id)}
        >
          <span className="tab-label">{dim.label}</span>
          <span className="tab-number">{dim.number}</span>
        </button>
      ))}
    </div>
  );
}







